import $ from 'jquery'; // eslint-disable-line import/no-extraneous-dependencies
import { getCurrentBreakpoint } from '../utilities/device';
import { breakpoints } from '../common/constants/breakpoints';
import { debounce } from '../utilities/functions';

const mapAndViewContentElements = `
    <img src="${window.sortAndViewIcon}" alt="Sort and view" />
    <span>Sort and view</span>
    <svg class="fw-icon-sprite chevron-icon" role="presentation">
        <use href="${window.iconSpriteMedium}chevron-down"></use>
    </svg>
`

export default () => {
    const $dropdowns = $('#hotel-results-controls').add('#hotel-controls-money').find('select');
    // Trigger map from mobile map
    // proxy trigger

    const mapOverlay = () => {
        $('#hotel-results-controls-mobile-map').on('click', () => {
            $('#resizeTrigger').trigger('click');
        });
    };

    // Expand and hide filters on click

    $('#hotel-results-utilities').on('click', '#hotel-results-controls-mobile', () => {
        $('#hotel-results-utilities').toggleClass('mobileActive');
        $('#hotel-results-controls').toggle();
    });

    const largeScreenOrSmaller = () =>
        getCurrentBreakpoint() === breakpoints.xSmall ||
        getCurrentBreakpoint() === breakpoints.small ||
        getCurrentBreakpoint() === breakpoints.medium ||
        getCurrentBreakpoint() === breakpoints.large;

    const isSmallScreen = () =>
        getCurrentBreakpoint() === breakpoints.xSmall ||
        getCurrentBreakpoint() === breakpoints.small;

    const isMediumOrLarge = () =>
        getCurrentBreakpoint() === breakpoints.medium ||
        getCurrentBreakpoint() === breakpoints.large;

    const mobileFilterUI = () => {
        const $resultsControlWrapper = $('#hotel-results-utilities');
        const $mapControl = $('#hotel-controls-view');
        const mapLink = $('#hotel-controls-view a').attr('href');
        const $mobileFilterUI = $('#hotel-results-controls-mobile');
        const $mobileMap = $('#hotel-results-controls-mobile-map');
        const hasMobileMapUI = $mobileMap.length > 0;
        const hasMobileFilterUI = $mobileFilterUI.length > 0;
        const hasMap = $mapControl.length > 0;
        const $hotelResultsControls = $('#hotel-results-controls');

        $resultsControlWrapper.removeClass('mobileActive');

        if (largeScreenOrSmaller()) {
            $hotelResultsControls.hide();
            if (isSmallScreen()) {
                if (hasMap) {
                    $mapControl.hide();
                    if (!hasMobileFilterUI && !hasMobileMapUI) {
                        $hotelResultsControls.before(
                            `
                                <div id="hotel-results-controls-mobile-map">
                                    <a href="${mapLink}class="search-map">Map View</a>
                                </div>
                                <div id="hotel-results-controls-mobile" role="button" tabindex="0" aria-label="Sort and view">
                                    Sort and view!!!!
                                </div>
                            `
                        );
                        mapOverlay();
                    } else if (hasMobileFilterUI && !hasMobileMapUI) {
                        $mobileFilterUI.before(`<div id="hotel-results-controls-mobile-map"><a href="${mapLink}class="search-map">Map View</a></div>`);
                        mapOverlay();
                    }
                } else {
                    if (!hasMobileFilterUI) {
                        $hotelResultsControls.before(`<div id="hotel-results-controls-mobile" class="hotel-results-controls-mobile fullWidthControl" role="button" tabindex="0" aria-label="Sort and view">${mapAndViewContentElements}</div>`);
                    }
                }
            } else {
                if (hasMap) {
                    $mapControl.show();
                    $('#hotel-results-controls-mobile-map').remove();
                }
            }

            if (isMediumOrLarge() && !hasMobileFilterUI) {
                const sortView = `
                    <div id="hotel-results-controls-mobile" class="hotel-results-controls-mobile${!hasMap ? ' fullWidthControl' : ''}" role="button" tabindex="0" aria-label="Sort and view">
                        ${mapAndViewContentElements}
                    </div>
                `;
                $hotelResultsControls.before(sortView);
            }
        } else {
            $hotelResultsControls.show();
            $mapControl.show();
            $mobileFilterUI.remove();
            $mobileMap.remove();
        }
    };

    const debouncedMobileFilter = debounce(mobileFilterUI, 250);

    $(window).resize(debouncedMobileFilter);

    mobileFilterUI();

    // Submit the form on

    $dropdowns.each((index, select) => {
        $(select).on('change', (event) => {
            $(event.currentTarget).parents('form').submit();
        });
    });
};
